import { useState } from "react";
import { faqs } from "@/mocks/faqs";

export default function FaqAccordion({ limit }: { limit?: number }) {
  const [open, setOpen] = useState<number | null>(0);
  const items = limit ? faqs.slice(0, limit) : faqs;

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
      {items.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={f.q}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left md:px-5"
              aria-expanded={isOpen}
            >
              <span className="flex items-center gap-3 text-sm font-bold text-foreground-950 md:text-base">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-bold text-secondary-900">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {f.q}
              </span>
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all duration-200 ${
                  isOpen ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                }`}
              >
                <i className="ri-arrow-down-s-line text-lg" aria-hidden="true"></i>
              </span>
            </button>
            {isOpen && (
              <p className="px-4 pb-4 pl-[52px] text-sm leading-7 text-foreground-600 md:px-5 md:pl-[54px]">
                {f.a}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}